import React, { useContext } from 'react'
import { Container } from 'react-bootstrap'
import SSRProvider from 'react-bootstrap/SSRProvider'
import { graphql, useStaticQuery } from 'gatsby'
import { useLocation } from '@reach/router'
import cx from 'classnames'
import { StoreContext } from '../context/store-context'
import { AltBanner } from './banners/AltBanner/AltBanner'
import { MainBanner } from './banners/MainBanner/MainBanner'
import { AltFooter } from './navigation/Footer/AltFooter/AltFooter'
import { Footer } from './navigation/Footer/Footer'
import { Header } from './navigation/Header/Header'
import { SkipNavContent, SkipNavLink } from './navigation/SkipNav/SkipNav'
// import { Footer } from "./navigation/Footer"
import { Seo } from './seo'

const Layout = ({ className, children }) => {
  const { setHiddenIds } = useContext(StoreContext)
  const location = useLocation()
  const keys = ['utm_source', 'utm_medium', 'utm_campaign', 'gclid', 'fbclid']

  const data = useStaticQuery(graphql`
    {
      allShopifyProduct(
        filter: { collections: { elemMatch: { handle: { eq: "hidden" } } } }
      ) {
        edges {
          node {
            shopifyId
          }
        }
      }
    }
  `)

  React.useEffect(() => {
    const params = new URLSearchParams(location.search)

    let utms = JSON.parse(localStorage.getItem('r4u_utms')) || {
      utm_source: 'Unknown',
      utm_medium: 'Unknown',
      utm_campaign: 'Unknown',
      gclid: 'Unknown',
      fbclid: 'Unknown',
    }

    if (
      !!params.get('utm_source') ||
      !!params.get('utm_medium') ||
      !!params.get('utm_campaign') ||
      !!params.get('gclid') ||
      !!params.get('fbclid')
    ) {
      keys.forEach((key) => {
        if (!!params.get(key)) {
          utms[key] = params.get(key)
        }
      })
    }

    const _ga = ('; ' + document.cookie).split(`; _ga=`).pop().split(';')[0]
    if (!!_ga) {
      utms['_ga'] = _ga
    }

    localStorage.setItem('r4u_utms', JSON.stringify(utms))

    const hiddenProductIds = data.allShopifyProduct.edges.map(
      (item) => item.node.shopifyId,
    )
    setHiddenIds(hiddenProductIds)

    if (typeof window !== 'undefined') {
      if (!!window.fbq) {
        window.fbq('track', 'PageView')
      }
    }
  }, [])

  return (
    <div className={cx(className, 'pt-[152px] md:pt-[140px]')}>
      <Seo />
      <SSRProvider>
        <SkipNavLink />
        <Header />
        <SkipNavContent>
          <div className='inner-layout'>{children}</div>
        </SkipNavContent>
        <Footer />
        <AltFooter />
      </SSRProvider>
    </div>
  )
}

export default Layout
